<template>
  <div class="main" >
    <template v-if="$route.params.title === undefined">
      <Banner/>
      <h1>Programs for Independents</h1>
      <Program :data="latest_program" @setSelected="setSelected(latest_program)"/>
      <h3 v-if="programs.length > 0">Other Upcoming Programs</h3>
      <Program class="upcoming" v-for="(program,i) in programs" :key="i" :data="program" @setSelected="setSelected(program)" />
      <ProgramRegistrationForm v-if="selected_program !== {}" :program="selected_program" @unSelect="selected_program = {};" :key="selected_program.id" />
    </template>
    <template v-else>
      <PlainRegistrationForm v-if="selected_program !== {}" :program="selected_program" @unSelect="selected_program = {};" :key="selected_program.id" style="padding: 0; width: 100%; max-width: unset" />
    </template>
  </div>
</template>

<script>
import Banner from "@/components/Banner";
import Program from "@/components/Program";
import ProgramRegistrationForm from "@/components/ProgramRegistrationForm";
import PlainRegistrationForm from "@/components/PlainRegistrationForm";

export default {
  name: "Programs",
  components:{
    PlainRegistrationForm,
    Banner,
    Program,
    ProgramRegistrationForm,
  },
  data:()=>({
    selected_program:{},
    latest_program: {
      id:'edm060420212',
      title:'Build Your Financial Future! Simple & Powerful Investing Strategies for Individuals and Families',
      definition:`<iframe width="1280" height="720" src="https://www.youtube.com/embed/H4jcjFKMwBg?rel=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe><p>The I Institute offers a full-day intensive  Build Your Financial Future! Simple & Powerful Investing Strategies for Individuals and Families program that provides insightful and necessary step by step guidance for individuals and families to design their financial future.</p><p>In this program, we promise incredibly new insights and an education in powerful investing strategies that can serve you a lifetime. You will learn the strategies and advice from some of the greatest investors in the world, who saw through Wall Street’s incompetence quite a long time ago.This program provides step by step guidance for evaluating your financial needs and determine options for aligning for those needs. Simple. Powerful.</p><p>Building Your Financial Future requires significant knowledge of investing and financial planning and is designed to help independents learn how to sufficiently maximize their returns. This exclusive program is taught by one of the most successful accountants today and includes lessons from his years of experience on Wall Street and in the financial industry.</p>`,
      price:'899',
      event_date:'June 4, 2021',
      closing_date:'June 4, 2021 14:00 EST',
      event_duration:'All Day',
      has_payment:1,
      show_date:1,
      article:`<iframe width="1280" height="720" src="https://www.youtube.com/embed/H4jcjFKMwBg?rel=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe><p>The I Institute offers a full-day intensive  Build Your Financial Future! Simple & Powerful Investing Strategies for Individuals and Families program that provides insightful and necessary step by step guidance for individuals and families to design their financial future.</p><p>In this program, we promise incredibly new insights and an education in powerful investing strategies that can serve you a lifetime. You will learn the strategies and advice from some of the greatest investors in the world, who saw through Wall Street’s incompetence quite a long time ago.This program provides step by step guidance for evaluating your financial needs and determine options for aligning for those needs. Simple. Powerful.</p><p>Building Your Financial Future requires significant knowledge of investing and financial planning and is designed to help independents learn how to sufficiently maximize their returns. This exclusive program is taught by one of the most successful accountants today and includes lessons from his years of experience on Wall Street and in the financial industry.</p><p>The I Institute has brought in Professor Joel Litman, one of the most notable anti-Wall Street champions of the individual and family investor. With tens of thousands of readers - including 200 of the 300 largest money managers on the planet AND thousands of everyday family investors - Prof Litman has earned their trust with a 30-year career in researching and exposing flaws in the financial and investment worlds.</p><div class="speaker"><h2>About the Speaker</h2><div><div><p><b>Joel Litman</b> is President and CEO of Valens Research, a global corporate performance and investment research and analytics firm. In the role of Chief Investment Strategist, he advises institutional investors in equities, corporate credit, and macroeconomic strategy. He is also a member of the Board of Directors of COL Financial Group, a leading brokerage firm in Asia (PSE:COL).</p><p>Litman has been on CNBC, quoted in Barron’s and Institutional Investor, and interviewed in Forbes. He has published in Harvard Business Review, is a top contributor to SeekingAlpha, and co-authored the highly-acclaimed book, DRIVEN: Business Strategy, Human Actions, and the Creation of Wealth. He also conducts seminars regularly for financial and industry conferences around the world such as CFA and CPA chapters.</p><p>Litman is Chair of the UAFRS Advisory Council which is spearheading usage of Uniform Adjusted Financial Reporting Standards aka Uniform Accounting. He is a member of CFA Institute, the global association for investment professionals, and the Association of Certified Fraud Examiners.</p></div><div><img src="${require('@/assets/images/JoelLitman.png')}"/><h3>Prof. Joel Litman</h3></div></div></div><h3>Program Details</h3><p>In this highly interactive live program, Professor Joel Litman will teach the foundations for building your financial future. He will cover topics such as how to invest, in which areas to invest, and all other important points that Wall Street financial analysts overlook or would prefer to sweep under the rug.</p><p>The program will take all day from 12 to 6 PM EST and will include details of the program content.</p><p>At the end of the program, there will be a Q&A session where you can ask all your questions about the finance & investment sector and the content of the program.</p><h3>Program Outcomes</h3><ul><li>Successfully determining how much to invest and in fixed income, equity and securities</li><li>Developing a sound understanding of your investment timetables</li><li>Confidently applying individual and family investment strategies</li><li>Understanding different investment environments and planning future investments accordingly</li><li>Learning the financial freedom cycle and effects of each step</li></ul>`,
    },
    programs:[
      {
        id:'gm06302021',
        title:'Guru Marketing: Being & Building Your Personal Brand',
        definition:`<iframe src="https://www.youtube.com/embed/nOBMJqoSmDs?rel=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe><p>This master class introduces the tools and techniques to solidify a personal brand as an independent. Designed explicitly for independents who are either new to independent work or are looking to significantly scale their micro-business, this information session will introduce you to the strategies and frameworks for building solid brand equity.</p>`,
        price:'599',
        event_date:'June 30, 2021',
        closing_date:'June 30, 2021 18:00 EDT',
        event_duration:'All Day',
        has_payment:1,
        show_date:1,
        banner:'https://transcend-websites.s3.amazonaws.com/the-i-institute/programs/Guru_Marketing-20210630.png',
        article:'<iframe src="https://www.youtube.com/embed/nOBMJqoSmDs?rel=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe><p>The Guru Marketing Program is designed for independents to leverage the skills, tools and available systems that help build personal influence and a strong independent brand. This highly interactive program - built to focus on individual needs & outcomes - develops skills around key areas of brand development including: social media optimization, independent community networking, existing systems (e.g. Marketplace) and strategic brand management. The program has been designed by some of the most successful independents today and includes the feedback of hundreds of successful independents who have built incredibly strong brands. Program outcomes for the one-day session include:</p><ul><li>Analyzing and applying Sales/Marketing tactics to build business as an Independent Professional</li><li>Confidently building a personal brand as a Independent Professional via Social Media</li><li>Confidently applying strategic networking tactics and approaches</li><li>Introducing and exploring the existing systems and resources for Independents</li></ul><p>Participants are strongly encouraged to have a sense of professional brand goals prior to registration.</p>',
      },

      {
        id:'l07162021',
        title:'Leadership: Leading Remotely as an Independent',
        definition:'<p>This program explores strategies for leading teams remotely as an independent. Themes in the program include: establishing trust, structuring work flows, maximizing engagement and commitment, and addressing key cultural challenges. During this full day session, independents will examine a wide range of topics that independents encounter when leading multicultural virtual teams.</p>',
        price:'599',
        event_date:'July 16, 2021',
        closing_date:'July 16, 2021 18:00 EST',
        event_duration:'All Day',
        has_payment:1,
        show_date:1,
        article:`<p>This program explores strategies for leading teams remotely as an independent. Themes in the program include: establishing trust, structuring work flows, maximizing engagement and commitment, and addressing key cultural challenges. During this full day session, independents will examine a wide range of topics that independents encounter when leading multicultural virtual teams. Specific program topics include:</p><ul><li>High Performing Team Metrics</li><li>Diversity, Equity and Inclusion initiatives</li><li>Virtual Communication tools</li><li>Conflict Resolution & Mediation</li><li>Best practices for team structure and collaboration</li></ul><p>Overall, the program is designed to quickly improve your ability to effectively manage a remote or virtual team in the world of independent work.</p>`,
      },
      {
        id:'c0209-102021',
        title:'Certified Self Employed - Certificate Program',
        definition:'<p>CSE(Certified Self Employed) certification involves hard-skills training that allows independent professionals to run their business through government-approved processes and commercially available systems. It provides the tools and access for independents to build their own safety nets and properly fund their taxes with third party verification. The CSE solution is a people- implemented privilege that liberates workers to become independent on their own terms.</p>',
        price:'1,072',
        event_date:'February 09 - 10, 2021',
        closing_date:'February 10, 2021 18:00 EST',
        event_duration:'2 Full Days, 10am - 6pm EST',
        has_payment:1,
        article: `<p>The mission of the CSE solution is simple, direct, and critical: it creates worker-driven steps that empower independents to create partnerships with customers and clients, thus removing the paternal dependences of traditional employment in which a business provides benefits that limit the independents’ mobility. As is the case with obtaining other credentialing and certifications, the process for achieving CSE status would be thorough, but fair and enabling.</p><p><i>General CSE Aims</i></p><ul><li>Provide certainty and clarity surrounding the norms and practices of employee-employer relationships in the 21st century</li><li>Provide awareness of government-approved tools and systems for willing independent professionals</li><li>Provide an introduction to skills and frameworks that allow independent professionals to successfully grow their business in the workplace</li><li>Provide an introduction to skills and frameworks that allow independent professionals to build their own safety nets and and financial plans</li></ul><p>The CSE program-level learning outcomes are separated into categories that are recognized by The I Institute as being critical to the aims of MBO Partners and the Independent Contractors and Enterprises they serve. These are: (1) Critical/Analytical Thinking, Strategy and Decision Making (2) Leadership, Teamwork and Diversity, (3) Networking, Stakeholder Management, and Communication (4) Practical Skills, Compliance, Legal and Tax.</p>`,
      }
    ],
  }),
  methods:{
    setSelected(program){
      this.selected_program = program;
    },
    unSelect(){
      this.selected_program = {};
    }
  },
  beforeMount() {
    let title = this.$route.params.title;
    let programs = this.programs.concat(this.latest_program);
    programs.forEach((program)=>{
      if(program.title === title){
        this.selected_program = program;
      }
    });

  },
  beforeCreate() {
    document.title = "Programs for Independents - The I Institute"
  },
  beforeDestroy() {
    document.getElementsByTagName('body')[0].style.overflow = 'auto';
  },
  watch:{
    selected_program: function(program){
      if(program.id !== undefined && this.$route.params.title === undefined){
        document.body.style.overflowY = 'hidden';
      }else{
        document.body.style.overflowY = 'auto';
      }
    }
  }
}
</script>
<style scoped lang="scss">
.row{
  margin-bottom: 100px;

}
h1{
  margin: 0 auto 70px;
}
h3{
  color: #919699;
  padding-bottom: 20px;
  margin-bottom: 40px;
  border-bottom:solid 1px #dddddd;
  font-size: 24px;
}
@media screen and (max-width: $vw_3) {
  .row {
    > div:nth-of-type(1) {
      margin-bottom: 30px;
    }

  }
}
</style>
<style lang="scss">
.popup iframe{
  display: none;
}
iframe{
  display: block;
  width: 100%;
  max-width: 800px;
  height: 50vw;
  margin: auto auto 30px;
  max-height: 450px;
  min-height: 165px;
}
.speaker{
  $offset: (100% - $global_width)*2;
  width: 100%;
  max-width: 100%;
  background-color: $gray;
  padding: 35px 27.2%;
  position: relative;
  left: -27.2%;
  p{
    color: #444;
  }
  img{
    height: 200px;
    width: auto;
  }
  h2,h3{
    color: $dark_blue;
    flex: 1 1 100%;
    font-weight: normal;
  }
  h3{
    font-size: 18px;
    font-weight: bold;
    color: #444;
  }


    >div{
      display: flex;

      >div{
        &:first-of-type{
          margin-right: 60px;
        }
        display: flex;
        flex-direction: column;
        align-items: center;
      }
    }
  p:last-of-type{
    margin-bottom: 0;
  }
  margin-bottom: 29px;
}
body{
  overflow-x: hidden;
}
@media screen and (max-width: $vw_2) {
  .speaker  {
    margin-bottom: 22px;
  }
}
@media screen and (max-width: $vw_3) {
  .speaker{
    h2{
      font-size: 20px;
    }
    img{
      height: 150px;
    }
  }
}

@media screen and (max-width: $vw_4) {
  .speaker  {
    img{
      height: 200px;
    }

      >div{
        flex-direction: column-reverse;
        >div{
          margin:0!important;
        }
      }
  }
}
</style>